import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({
        name: "", email: "", password: "",
        birthday_day: "", city: "", pet: "",
    });
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await register({
                name: form.name,
                email: form.email,
                password: form.password,
                security_answers: {
                    birthday_day: form.birthday_day,
                    city: form.city,
                    pet: form.pet,
                },
            });
            navigate("/dashboard", { replace: true });
        } catch (err) {
            setError(formatApiError(err, "No pudimos crear tu cuenta"));
        } finally { setLoading(false); }
    };

    const googleLogin = () => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/auth/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    return (
        <div className="auth-shell" data-testid="register-page">
            <section className="auth-hero">
                <div className="brand">itotal<span className="accent">4u</span></div>
                <div>
                    <h2>Crea tu cuenta en <em>segundos</em>.</h2>
                    <p className="tag">Tu cuenta te permite abrir tickets, seguir su estado y conversar con los agentes. Configura 3 preguntas de seguridad para recuperar tu contraseña si la olvidas.</p>
                </div>
                <div className="meta">tus datos están encriptados · bcrypt + JWT</div>
            </section>

            <section className="auth-pane">
                <div className="auth-card">
                    <h3>Crear cuenta</h3>
                    <p className="sub">Empieza ahora — toma menos de 30 segundos.</p>

                    {error && <div className="alert alert-error" data-testid="register-error">{error}</div>}

                    <form onSubmit={submit} className="row" style={{ gap: 14 }}>
                        <div className="field">
                            <label>Nombre completo</label>
                            <input className="input" value={form.name} onChange={set("name")} required data-testid="register-name" />
                        </div>
                        <div className="field">
                            <label>Correo electrónico</label>
                            <input type="email" className="input" value={form.email} onChange={set("email")} required autoComplete="email" data-testid="register-email" />
                        </div>
                        <div className="field">
                            <label>Contraseña (mínimo 8 caracteres)</label>
                            <input type="password" className="input" value={form.password} onChange={set("password")} required minLength={8} autoComplete="new-password" data-testid="register-password" />
                        </div>

                        <div className="alert alert-info" style={{ marginBottom: 0 }}>
                            <b>Preguntas de seguridad</b> — te ayudarán a recuperar tu contraseña sin soporte.
                        </div>
                        <div className="row row-3">
                            <div className="field">
                                <label>Día de tu cumpleaños</label>
                                <input className="input" value={form.birthday_day} onChange={set("birthday_day")} placeholder="Ej. 15" required data-testid="register-birthday" />
                            </div>
                            <div className="field">
                                <label>Ciudad de nacimiento</label>
                                <input className="input" value={form.city} onChange={set("city")} placeholder="Ej. CDMX" required data-testid="register-city" />
                            </div>
                            <div className="field">
                                <label>Nombre de tu mascota</label>
                                <input className="input" value={form.pet} onChange={set("pet")} placeholder="Ej. Luna" required data-testid="register-pet" />
                            </div>
                        </div>

                        <button className="btn btn-primary btn-block" type="submit" disabled={loading} data-testid="register-submit">
                            {loading ? <span className="loader" /> : "Crear cuenta"}
                        </button>
                    </form>

                    <div className="divider">o</div>
                    <button className="btn btn-google btn-block" onClick={googleLogin} data-testid="register-google">
                        Continuar con Google
                    </button>

                    <div className="switch">
                        ¿Ya tienes cuenta? <Link to="/login" data-testid="register-to-login">Iniciar sesión</Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
